import "./App.css";
import { useEffect, useState } from "react";
import MyRecipesComponent from "./MyRecipesComponent";
import { FaSearch } from "react-icons/fa";

function App() {

  const MY_ID = "56b186b0"
  const MY_KEY = "d7bebce0b75170041ded39c7ede343ad"

  const getResponse = async () => {
    const response = await fetch(
      `https://api.edamam.com/api/recipes/v2?type=public&q=${wordSubmitted}&app_id=${MY_ID}&app_key=${MY_KEY}`
    );
    console.log(response);
    const data = await response.json();
    setMyRecipes(data.hits);
  };

  const [mySearch, setMySearch] = useState("");
  const [myRecipes, setMyRecipes] = useState([]);
  const [wordSubmitted, setWordSubmitted] = useState("");

  useEffect(() => {
    getResponse();
  }, [wordSubmitted]);

  const myRecipeSearch = (e) => {
    console.log(e.target.value);
    setMySearch(e.target.value);
  };

  const finalSearch = (e) => {
    // to prevent the page from reloading
    e.preventDefault();
    setWordSubmitted(mySearch);
  };

  return (
    <div className="App">
      <div className="container">
        <h1>Find a Recipe</h1>
      </div>

      <div className="container">
        <form onSubmit={finalSearch}>
          <input
            className="search"
            placeholder="Search..."
            onChange={myRecipeSearch}
            value={mySearch}
          ></input>
          <button>
            <FaSearch className="searchIcon" />
          </button>
        </form>
      </div>

      <div className="elements">
        {myRecipes?.map((item, index) => (
          <MyRecipesComponent
            key={index}
            label={item.recipe.label}
            image={item.recipe.image}
            calories={item.recipe.calories}
            ingredients={item.recipe.ingredientLines}
            link={item.recipe.url}
          />
        ))}
      </div>
    </div>
  );
}

export default App;
